import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';

@Component({
    selector: 'app-card-payment-queue',
    templateUrl: './card-payment-queue.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./card-payment-queue.component.scss']
})
export class CardPaymentQueueComponent implements OnChanges {
    @Input() public systemPaymentData: any = [];
    @Input() public system: System = new System();
    @Input() public isSent: boolean = false;
    @Input() public paymentId: string = '';
    @Input() public showInitial: boolean = true;
    public textTooltip: string = '';
    public showTextEmpty: boolean = false;
    public timeAverage: number = 0;
    public sizeCard: { [key: number]: number } = {
        100: 200,
        80: 160,
        50: 100,
        20: 70
    };

    public ngOnChanges(): void {
        this.showTextEmpty = this.systemPaymentData.length === 0;
    }

    public setFilledAndFillingCard(valueHeight: number): number {
        let heightCard: number = 140; //Height -1px to border

        return (valueHeight * heightCard) / 100;
    }

    public getWaitTime(dataSystemPayment: any): string {
        let auxDate: number = (Date.now() - new Date(dataSystemPayment.attributes.ready_to_pay_at).valueOf()) / 3600000;
        let dateTooltip: string = auxDate < 1 ? Math.trunc(auxDate * 60).toString() + ' min' : Math.trunc(auxDate).toString() + ' hrs';

        return dateTooltip;
    }

    public setTooltip(dataSystemPayment: any): string {
        if (dataSystemPayment.attributes.ready_to_pay_at === undefined) {
            return '';
        }
        this.timeAverage = this.system.relationships.system_information.data[0].attributes.time_average;
        let auxDate: number = (Date.now() - new Date(dataSystemPayment.attributes.ready_to_pay_at).valueOf()) / 3600000;
        let dateTooltip: string = auxDate < 1 ? Math.trunc(auxDate * 60).toString() + ' min' : Math.trunc(auxDate).toString() + ' hrs';
        if (this.isSent) {
            return `FINALIZADO hace ${dateTooltip} \n100% pagos recibidos \n0% pagos restan recibir`;
        }

        return '<p>Tiempo de pago medio <b>this.system.relationships.system_information.data[0].attributes.time_average</b></p>';

        // return `Tiempo de pago medio  \n En espera hace ${dateTooltip} \n${dataSystemPayment.attributes.filled}% pagos recibidos\n${100 -
        //     dataSystemPayment.attributes.filled}% pagos restan recibir`;
    }
}
